import { Injectable } from '@angular/core';
import { Query, gql } from 'apollo-angular';
import { StorefrontBasicFragment, StorefrontBasic } from './storefront-basic.fragment';

@Injectable({
  providedIn: 'root'
})
export class GetAllStorefrontsGQL extends Query<GetAllStorefrontsGQLResponse> {
  document = gql`
  query getAllStorefronts {
    storefronts {
      ...StorefrontBasic
    }
  }
  ${StorefrontBasicFragment}
  `;
}

interface GetAllStorefrontsGQLResponse {
  storefronts: StorefrontBasic[];
}


